@let label = labelSg();
@let value = valueSg();
@let isOpen = isOpenSg();

<div class="atn-ds-input-field">
  @if (label) {
    <span class="atn-ds-input-field__label">
      {{ label }}
    </span>
  }
  <div
    class="atn-ds-iconpicker"
    (click)="isOpenSg.set(!isOpen)"
    #overlayOrigin
  >
    @if (value) {
      <i class="atn-icon atn-{{ value }} atn-blue"></i>
    } @else {
      <div class="atn-ds-iconpicker__placeholder">Select...</div>
    }
    <i class="fas fa-sort-down atn-ds-iconpicker__open-icon"></i>
  </div>
</div>

@if (isOpen) {
  <atn-ds-attached-overlay
    [origin]="overlayOrigin"
    (backdropClick)="isOpenSg.set(false)"
  >
    <div class="atn-ds-iconpicker__overlay">
      <div class="atn-ds-iconpicker__icons-wrapper">
        <div class="atn-ds-iconpicker__icons">
          @for (icon of icons; track $index) {
            <div
              class="atn-ds-iconpicker__icon"
              [class.atn-ds-iconpicker__icon--selected]="icon === value"
              (click)="selectIconHandler(icon)"
            >
              <i class="atn-icon atn-{{ icon }} atn-blue"></i>
            </div>
          }
        </div>
      </div>
    </div>
  </atn-ds-attached-overlay>
}
